import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges, ElementRef, ViewChild, OnDestroy, ChangeDetectorRef, AfterViewInit } from '@angular/core'
import { Linqset, LinqsetNode, NODE_SUPERTYPE, NODE_TYPE, ACTION_FREQUENCY_TYPE, NodeInsights, getDurationDescription, FREQUENCY_TYPE, NODE_NAME_MAX, NODE_NAME_MIN, NODE_DESCRIPTION_MAX, ORGANISATION_MODEL_KEY, getInsights, CURRENT_STATE_PROJECT_KEY, isModelNode, isRolePeople, isRoleSystem, isOrganisationNode, isSystemInfrastructure, NodeProperties, createNodeProperties, NODE_URL_MAX, NODE_NOTES_MAX, Emissions, EMISSIONS_RATE, NO_ROLE, getEmissionRateDescription, EDGE_TYPE, convertModelledCapacityToTotal, getSuperTypeName, getIndexValue, getTempoMessageAndColour, usesCalculatedFrequency, LinqsetEdge, TUTORIAL_MODEL_KEY, isSupplyChain, FILTER_MODEL_KEY, updateTagsOnProperties, cloneLinqsetNode, getInsightsForNode, getOrderedInformationAssets, OUTPUT_VALUE_SOURCE, WORK_TYPE, SYSTEM_KIND } from '../../common/linqset-model';
import { suggestSystemKind, SYSTEM_KIND_LABELS } from '../../common/system-kind';
import { readAsWait } from '../../common/exception-work';
import { informationTypeOf } from '../../common/information-type';
import { INFORMATION_HELD_LABELS, informationHeld } from '../../common/information-value';
import { MatDialog } from '@angular/material/dialog';
import { FrequencyDialogComponent, FrequencyDialogData, FrequencyDialogResult } from '../tempo-dialog/frequency-dialog.component';
import { NodeService, NodeTypeInfo } from '../../model-services/node.service';
import { ACTION_TYPE, CARBON_SCOPE, EMISSION_FACTOR_TYPE, EmissionFactor, InformationAsset, ModelInsights, Organisation, getCarbonScopeIcon, getCarbonScopeShortDescription, getTagGroupsForModel, defaultCapacityHours, getUnitsForEmissionFactor, getCurrency, DEFAULT_CURRENCY } from '../../common/organisation';
import { LabelService } from '../../model-services/label.service';
import { LABEL_TYPES } from '../../model-services/model-item-enums';
import { User } from '../../common/user';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import { OrganisationService } from '../../organisation/organisation.service';
import { TagsService } from '../../organisation/tags/tags-service';
import { INSIGHT_VALUE_TYPE, InsightCard } from '../../ui-components/insight-cards/insight-cards.component';
import { Observable, Subscription, map, merge, startWith, tap } from 'rxjs';
import { FUNCTION } from '../../model-services/function.service';
import { CarbonEmissionsDialogComponent, CarbonEmissionsDialogData } from '../carbon/carbon-emissions-dialog.component';
import { v4 } from 'uuid';
import { editInformationAsset } from '../information-asset/information-asset-dialog.component';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../ui-components/dialogs/confirm-dialog.component';
import { CHANGE_TYPE } from '../../common/linqset-change-model';
import { GraphProcessingService } from '../../model-services/graph-processing.service';
import { AdjacencyTypes, IGraph, INode } from '@yfiles/yfiles';
import { GraphService } from '../../canvas/graph.service';

const OPEN_SECTIONS_KEY = "linq.nodeProperties.openSections"
const DEFAULT_OPEN_SECTIONS = ['details', 'frequency']

@Component({
    selector: 'app-node-properties',
    templateUrl: './node-properties.html',
    styleUrls: ['node-properties.css'],
    standalone: false
})
export class NodePropertiesComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() nodes: INode[]
    @Input() graph:IGraph
    @Input() organisation:Organisation
    @Input() organisationLinqset:Linqset

    @Input() readOnlyGraph:boolean
    @Input() linqset: Linqset
    @Input() modelInsights: ModelInsights // we have this so that gets notified of change after processing

    // which collapsible sections are open; shared across nodes so the panel keeps the same shape as you click around
    openSections:string[] = this.loadOpenSections()

    isSectionOpen(key:string) {
        return this.openSections.indexOf(key) >= 0
    }

    toggleSection(key:string) {
        this.openSections = this.isSectionOpen(key)?this.openSections.filter(s => s !== key):[...this.openSections, key]
        try {
            localStorage.setItem(OPEN_SECTIONS_KEY, JSON.stringify(this.openSections))
        }catch(err) {
            // storage unavailable; the choice just won't persist
        }
    }

    private loadOpenSections():string[] {
        try {
            const stored = JSON.parse(localStorage.getItem(OPEN_SECTIONS_KEY))
            if (Array.isArray(stored)) return stored
        }catch(err) {
            // storage unavailable or corrupt, fall back to defaults
        }
        return [...DEFAULT_OPEN_SECTIONS]
    }

    @Output() executeFunctionEvent = new EventEmitter<{function:FUNCTION, value?:any}>()

    informationAssetControl: FormControl<string> = new FormControl('');
    filteredInformationAssets: Observable<InformationAsset[]>;
    currentInformationAsset:InformationAsset
    sortedInformationAssets:InformationAsset[]
      
    readonly:boolean
    nodeGroupForm: FormGroup
    superType:NODE_SUPERTYPE|undefined
    nodeNames: any[]
    edgesOut:LinqsetEdge[]
    types:NodeTypeInfo[]
    edgesReadonly:boolean // whether edges out are readonly or not

    FREQUENCY_TYPE = FREQUENCY_TYPE
    ACTION_FREQUENCY_TYPE = ACTION_FREQUENCY_TYPE
    NODE_SUPERTYPE = NODE_SUPERTYPE
    NODE_TYPE = NODE_TYPE
    NODE_NAME_MAX = NODE_NAME_MAX
    NODE_NAME_MIN = NODE_NAME_MIN
    NODE_DESCRIPTION_MAX = NODE_DESCRIPTION_MAX
    NODE_URL_MAX = NODE_URL_MAX
    NODE_NOTES_MAX = NODE_NOTES_MAX

    linqsetNode:LinqsetNode
    selectedNode:LinqsetNode
    insights:NodeInsights // insights for this model

    tileInsights:any // insights selected to view results for

    models:any[]
    users:User[]
    
    newRoleNode:boolean = false
    newSystemUsedNode:boolean = false
    canEditCapacity:boolean = false
    canEditCosts:boolean = false

    existingNodes: LinqsetNode[]
    existingNodeKey: string

    tempo:{colour:string, message:string}

    nodeChangeSub:Subscription
    controlSub:Subscription

    cards:InsightCard[] = []
    invalidInsightsMessage:string = undefined

    emissionFactors:EmissionFactor[]
    emissionsMap:{}
    emissionRates:any[] = Object.values(EMISSIONS_RATE)

    // holds the currently edited propeties whether single or multi node
    nodeProperties:NodeProperties
    changing = false        // used to turn of changes while making a change

    showNodeSelection:boolean = false

    DISTANCE = 100
  
    @ViewChild('notesControl') notesControl: ElementRef<HTMLInputElement>;

    constructor(private nodeService: NodeService, private dialog: MatDialog, private formBuilder:FormBuilder, private organisationService:OrganisationService, private graphService:GraphService,
        private labelService:LabelService, private tagsSevice:TagsService, private graphProcessing:GraphProcessingService) {
    }

    ngAfterViewInit(): void {
        this.nodeChangeSub = this.graphProcessing.processCompletedEvent.subscribe(e => {
            this.createTiles()
            this.tempo = getTempoMessageAndColour(this.superType, this.nodeProperties, this.insights, this.linqset.workspaceKey, this.linqsetNode, defaultCapacityHours(this.linqset.organisation))
            //this.changeDetectorRef.detectChanges()
        })

    }

    ngOnDestroy() {
        if (this.nodeChangeSub) this.nodeChangeSub.unsubscribe()
        if (this.controlSub) this.controlSub.unsubscribe()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['nodes']) {
            this.informationAssetControl.reset()
            this.setup()
        }
    }

    setup() {
        this.users = this.organisationService.users||[]
        this.emissionFactors = this.organisation.emissionFactors

        // if single node selected set linqset node
        if (!this.nodes || this.nodes.length === 0) return

        this.linqsetNode = this.nodes[0].tag.node
        if (this.linqsetNode) {
            this.selectedNode = !this.linqset.isOrganisationModel() && this.linqsetNode     // we use this for the selection of existing nodes, so if linqsetnode is null we can still set a value
            this.superType = this.linqsetNode.superType

            this.nodeProperties = this.linqsetNode.properties || createNodeProperties()
            if (this.linqsetNode.superType === NODE_SUPERTYPE.INFRASTRUCTURE && !this.nodeProperties.units) this.nodeProperties.units = 1
            if (this.linqsetNode.superType === NODE_SUPERTYPE.INFRASTRUCTURE && !this.nodeProperties.lifetime) this.nodeProperties.lifetime = 1
        }
        this.canEditCapacity = false
        this.canEditCosts = false

        const invalidNodeKeys:string[] = []         // for system nodes cannot select any of thse because already attached to role/action/info

        this.nodeNames = this.nodes.filter(n => n.tag.node).reduce((a,n) => {
            // check whether selected nodes are all the same linq node
            if (this.linqsetNode && this.linqsetNode._key !== n.tag.node._key) {
                this.linqsetNode = undefined
                this.selectedNode = undefined
                this.nodeProperties = createNodeProperties()
            }

            // not same super type so clear it
            if (this.superType !== n.tag.node.superType) this.superType = undefined
            // people and roles without people can edit capapcity
            if (isRolePeople(n.tag.node.superType)) {
                const i = getInsights(n.tag.node, this.linqset)
                if (!i?.hasPeople && n.tag.node.type !== NODE_TYPE.EXTERNAL_ORGANISATION) this.canEditCapacity = true
            }
            if (!a.find(k => k._key === n.tag.node._key)) a.push(n.tag.node)

            if (n.tag.node.superType === NODE_SUPERTYPE.SYSTEM && this.linqset.isProcessModel()) {
                this.graph.edgesAt(n, AdjacencyTypes.OUTGOING).forEach(e => {
                    // find nodes this system attached to
                    this.graph.edgesAt(e.targetNode, AdjacencyTypes.INCOMING).forEach(e2 => {
                        if (e2.sourceNode !== n && e2.sourceNode.tag?.node?.superType === NODE_SUPERTYPE.SYSTEM) {
                            invalidNodeKeys.push(e2.sourceNode.tag.node._key)
                        }
                    })
                })
                
            }

            return a
        }, [])
                         
        this.models = undefined
        this.insights = undefined
        this.currentInformationAsset = undefined
        this.emissionsMap = {}
        this.sortedInformationAssets = getOrderedInformationAssets(this.organisation, this.linqset)

        // information nodes could be for another model
        this.types = []

        if (this.linqsetNode) {
            this.insights = getInsights(this.linqsetNode, this.linqset)

            this.setupModelsList()

            if (!this.nodeProperties.emissions) this.nodeProperties.emissions = []
            this.createEmissionsList(this.nodeProperties.emissions)

            if (this.linqsetNode.superType === NODE_SUPERTYPE.ACTION && !this.linqsetNode.properties.actionProcessType)
                this.linqsetNode.properties.actionProcessType = ACTION_FREQUENCY_TYPE.SUM
            
            const eio = this.linqset.edges.filter(e => e.sourceKey === this.linqsetNode._key || e.targetKey == this.linqsetNode._key)

            this.edgesOut = []
            if (this.linqsetNode.superType === NODE_SUPERTYPE.PEOPLE)
                this.edgesOut = eio.filter(e => e.sourceKey === this.linqsetNode._key && e.type === EDGE_TYPE.FULFILS)

            if (isSupplyChain(this.linqsetNode.superType))
                this.edgesOut = eio.filter(e => e.sourceKey === this.linqsetNode._key && (e.type === EDGE_TYPE.CREATE || e.type === EDGE_TYPE.SUPPORT || e.type === EDGE_TYPE.JOINS))

            this.canEditCosts = isSystemInfrastructure(this.superType) || this.superType === NODE_SUPERTYPE.PEOPLE || (this.superType === NODE_SUPERTYPE.ROLE && !this.insights?.hasPeople)           
        }

        // only types that are allowed under current graph connections
        this.types = this.superType?this.nodeService.getSuperTypeInfo(this.superType).nodeTypes.filter(t => {
            for (const iNode of this.nodes) {
                const n = iNode.tag.node
                const clone = cloneLinqsetNode(n)
                clone.type = t.type
                clone._key = n._key
                const eio = this.linqset.edges.filter(e => e.sourceKey === n._key || e.targetKey == n._key)
                for (const e of eio) {
                    if (e.sourceKey === n._key) {
                        const other = this.linqset.getNode(e.targetKey)
                        if (!this.graphService.canConnectLinqsetNodes(this.linqset, clone, other, true)) 
                            return false
                    }else {
                        const other = this.linqset.getNode(e.sourceKey)
                        if (!this.graphService.canConnectLinqsetNodes(this.linqset, other, clone, true)) 
                            return false
                    }
                }
            }
            return true
        }):[]

        if (this.superType && isRoleSystem(this.superType)) {
            this.existingNodes = this.organisationLinqset.nodes.filter(n => {
                if (!this.types.find(t => t.type === n.type)) return false
                return (invalidNodeKeys.indexOf(n._key) < 0 && !this.nodeNames.find(nn => nn._key === n._key) && (n.superType === this.superType && n.name && n.name.length>0))
            }).sort((a,b) => (a.name&&b.name)?a.name.localeCompare(b.name):-1)

            this.showNodeSelection = this.existingNodes.length > 0?true:false
        }else this.existingNodes = []


        this.setReadonly()
        this.tempo = getTempoMessageAndColour(this.superType, this.nodeProperties, this.insights, this.linqset.workspaceKey, this.linqsetNode, defaultCapacityHours(this.linqset.organisation))

        this.nodeGroupForm  = this.linqsetNode?this.formBuilder.group({
            name: [{value:this.linqsetNode.name, disabled:this.readonly||this.editPropertiesOnly()}, [Validators.required, Validators.minLength(NODE_NAME_MIN), Validators.maxLength(NODE_NAME_MAX), this.createCheckExistingNameValidator()]],
            description: [{value:this.linqsetNode.description, disabled:this.readonly||this.editPropertiesOnly()}, Validators.maxLength(NODE_DESCRIPTION_MAX)],
            type: [{value:this.linqsetNode.type, disabled:this.readonly||this.editPropertiesOnly()}, Validators.required],
            actionProcessType: [{value:this.nodeProperties.actionProcessType, disabled:this.readonly}, Validators.required],
            external: [{value:this.linqsetNode.external, disabled:(this.readonly || !this.canToggleExternal())}],
            tagKeys: [{value:this.nodeProperties.tagKeys?Object.values(this.nodeProperties.tagKeys):[], disabled:this.readonly}],
            url: [{value:this.linqsetNode.url, disabled:this.readonly}, Validators.maxLength(NODE_URL_MAX)],
            notes: [{value:this.linqsetNode.notes, disabled:this.readonly}, Validators.maxLength(NODE_NOTES_MAX)],
            userKeys: [{value:this.linqsetNode.userKeys, disabled:this.readonly}]
        }):
        // multiple nodes selected
        this.formBuilder.group({
            type: [{value:undefined, disabled:this.readonly}],
            actionProcessType: [{value:this.nodeProperties.actionProcessType, disabled:this.readonly}],
            tagKeys: [{value:this.nodeProperties.tagKeys?Object.values(this.nodeProperties.tagKeys):[], disabled:this.readonly}],
            external: [{value:false, disabled:(this.readonly || !this.canToggleExternal())}],
        })

        this.filteredInformationAssets = this.informationAssetControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '')),
        );

        if (this.linqsetNode && this.linqsetNode.informationAssetKey && this.organisation.informationAssets) {
            this.currentInformationAsset = this.organisation.informationAssets.find(a => a._key === this.linqsetNode.informationAssetKey)
            if (this.currentInformationAsset) this.informationAssetControl.setValue(this.currentInformationAsset.name)
        }

        // subscribe to change on each control
        if (this.controlSub) this.controlSub.unsubscribe()
        this.controlSub = merge(
            ...Object.keys(this.nodeGroupForm.controls).map(
                (controlName: string) =>
                    this.nodeGroupForm.get(controlName).valueChanges.pipe(
                        tap((value) => {
                            this.handleChange(controlName, value)
                        })
                    )
                )
            ).subscribe();

        this.createTiles()
    }

    private _filter(value: string): InformationAsset[] {
        const filterValue = value.toLowerCase();
  
        return this.sortedInformationAssets.filter(a => a.name.toLowerCase().includes(filterValue))
    }

    getInsightsName() {
        if (!this.insights) return ""

        const project = this.insights.projectKey && this.organisation.projects.find(p => p._key === this.insights.projectKey)
        const model = this.insights.modelKey !== ORGANISATION_MODEL_KEY && this.organisation.models.find(m => m._key === this.insights.modelKey)

        const name = (project?project.name + " - ":"Current state - ") + (model?model.name:"Organisation")
        return name
    }

    editPropertiesOnly() {
        return this.linqsetNode && this.isProject() && this.linqsetNode.projectKey !== this.linqset.workspaceKey
    }

    getNameError() {
        return `Name is required and must be less than ${NODE_NAME_MAX} characters`
    }

    isTeam() {
        return this.linqsetNode && this.linqsetNode.type === NODE_TYPE.TEAM
    }

    getNodeTypeName() {
        const i = this.types.find(i => i.type === this.nodeGroupForm.value.type)
        return i && i.name
    }

    usesCalculatedFrequency() {
        return usesCalculatedFrequency(this.nodeProperties)
    }

    openEmissionsDialog(emissions?:Emissions) {
        if (this.readonly) return

        const data:CarbonEmissionsDialogData = {name:this.linqsetNode.name, emissions, numberPeople:this.insights?.numPeople||0, numberUnits: this.linqsetNode.properties?.units||1, hours:this.tileInsights?.insights?.hours||0, lifetime:this.linqsetNode.properties?.lifetime||1}
        const dialogRef = this.dialog.open(CarbonEmissionsDialogComponent, {data, hasBackdrop:true, width:'800px'});

        dialogRef.afterClosed().subscribe((result:Emissions|undefined) => {
            if (!result) return
            const list = this.nodeProperties.emissions || []
            // the dialog works on a copy, so replace the edited entry or add the new one
            this.nodeProperties.emissions = result._key
                ? list.map(e => e._key === result._key ? result : e)
                : [...list, {...result, _key:v4()}]
            this.handleChange("emissions", this.nodeProperties.emissions)
            this.createEmissionsList(this.nodeProperties.emissions)
        });
    }

    openInformationAssetDialog(edit:boolean) {
        if (this.readonly) return
        
        void editInformationAsset(this.dialog, this.organisationService, edit ? this.currentInformationAsset : undefined, this.organisationLinqset?.nodes).then(saved => {
            // only attach an asset that was saved
            if (!saved) return

            this.sortedInformationAssets = getOrderedInformationAssets(this.organisation, this.linqset)
            this.informationAssetControl.setValue(saved.name)
            this.handleChange("informationAssetKey", saved)
        });
    }

    deleteEmissions(emissions:Emissions) {
        this.nodeProperties.emissions = this.nodeProperties.emissions.filter(e => e._key !== emissions._key)
        this.handleChange("emissions", this.nodeProperties.emissions)
        this.createEmissionsList(this.nodeProperties.emissions)
    }

    createEmissionsList(emissions:Emissions[]) {
        this.emissionsMap = emissions.reduce((m,e) => {
            const ef = this.organisation.emissionFactors?.find(ef => ef._key === e.emissionFactorKey)
            if (!ef) {
                if (!m['missing']) m['missing'] = []
                m['missing'].push({label:'Emission factor deleted', emissions:e, description:'<span>Unknown factor: choose another</span>'})
            }else {
                if (!m[ef.scope]) m[ef.scope] = []

                const units = ef && getUnitsForEmissionFactor(ef.type)
                const rateDescription = getEmissionRateDescription(e.rate)

                let value = ef.type === EMISSION_FACTOR_TYPE.NO_USAGE?1:e.value
                if (ef.type === EMISSION_FACTOR_TYPE.DISTANCE) value = value*(e.value2||0)

                const description = `<span>${ef.name}: ${value} ${units} ${rateDescription}</span>`
                const label = `${ef.scope.toString()} (${getCarbonScopeShortDescription(ef.scope)})`
                m[ef.scope].push({label, emissions:e, factor:ef, description})
            }
            return m
        }, {})
    }

    getEmissionScopes() {
        return Object.keys(this.emissionsMap)
    }

    isProject() {
        return !this.linqset.isCurrentState()
    }

    selectModel(event) {
        this.createTiles()
    }

    getAllSuperTypes() {
        return this.nodeService.nodeSuperTypes
    }

    getDuration() {
        return this.linqsetNode.properties.duration?getDurationDescription(this.linqsetNode.properties.duration):"No duration set"
    }

    getMultipleSelectionMessage() {
        if (this.superType) {
            const info = this.nodeService.getSuperTypeInfo(this.superType)
            return `You have selected the following ${info.name} nodes. Any changes will be applied to all nodes.`
        }else return "You have selected the following nodes. Because they are different types you cannot edit their properties."
    }

    getSelectNodePlaceHolder() {
        if (this.linqset.isOrganisationModel() || this.nodeNames.length>1) return "Select a node to merge node(s) into"
        else return "Select existing node or leave blank to create new"
    }

    getOutputNumber(percentage:number) {
        if (!this.insights) return 0
        if (this.linqsetNode.superType === NODE_SUPERTYPE.PEOPLE) {
            const roleEdges = this.linqset.edges.filter(e => e.sourceKey === this.linqsetNode._key && e.type === EDGE_TYPE.FULFILS)
            const total = roleEdges.reduce((t, e) => t += e.outputPercentage, 0)

            if (roleEdges.length === 0) return 0
            return Math.round(total===0?this.insights.modelledCapacity/roleEdges.length:this.insights.modelledCapacity*percentage/total)
        }else return Math.round(this.insights.numberProcessed*percentage/100)
    }

    async mergeNodes() {
        const nodes = this.nodeNames.map(n => n.name||'Missing name').join(', ')

        let messages = [`You are about to merge ${nodes} into ${this.selectedNode.name}.`, "Are you sure you want to do this, it cannot be undone?"];
        const dialogData = new ConfirmDialogModel("Confirm Action", messages, "merge", false, "Yes", "No");
    
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: "400px",
            data: dialogData
        });
    
        dialogRef.afterClosed().subscribe(async dialogResult => {
            if (dialogResult) {
                if (dialogResult.button === "Yes") {
                    this.executeFunctionEvent.emit({function:FUNCTION.MERGE_NODES, value:{toNode:this.selectedNode, fromNodeKeys:this.nodeNames.map(n => n._key)}})
                }
            }
        })
    }

    onExistingNodeChange(existingNode:any) {
        // only if not org model. org model must be merged by pressing merge nodes button
        if (this.linqset.isOrganisationModel() || (this.linqsetNode && this.linqsetNode._key === this.selectedNode._key)) return 

        const nodesToChange = this.nodes.map(n => n)
        // change current node to point to selected linqset node
        const edges = nodesToChange.reduce((edges, n) => {
            edges = edges.concat(this.graph.edgesAt(n).toArray())
            return edges
        }, [])

        const items = nodesToChange.concat(edges)
        // remove node and edges
        this.graphProcessing.createDeletedItemsEvent(items, false)

        // change linqset node
        nodesToChange.forEach(n => {
            n.tag.node = existingNode
            this.labelService.addLabelToNode(this.graph, n, existingNode.name, LABEL_TYPES.NODE_NAME)
        })

        // add new node and edges
        if (edges.length > 0) this.graphProcessing.createAddedItemsEvent(items, true)

        this.setup()
    }
   
    hasExistingNodes() {
        return this.existingNodes && this.existingNodes.length > 0
    }

    setReadonly() {
        // if node is associated with the current state and not the project
        if (this.readOnlyGraph) this.readonly = true
        else if (isOrganisationNode(this.superType)) this.readonly = false
        else {
            this.readonly = (this.nodeNames.find(n => n.modelKey && n.modelKey !== this.linqset.modelKey))?true:false
            this.edgesReadonly = false
            return
        }
        this.edgesReadonly = this.readonly
    }

    canToggleExternal() {
        if (!this.linqsetNode) return false
        if (this.readonly) return false
        if (!this.graph) return false
        if (!this.linqsetNode.external) return true

        const joins = this.graph.contains(this.nodes[0]) && this.graph.edgesAt(this.nodes[0], AdjacencyTypes.OUTGOING)
        const j = joins && joins.find(e => e.targetNode.tag?.model)
        return !j
    }

    onSelectedNodeChange(event:any) {
        if (event.node) {
            this.selectedNode = event.node
            this.onExistingNodeChange(event.node)
        }
        else if (this.linqsetNode) {
            this.selectedNode = undefined
            if (event.name !== this.linqsetNode.name) this.handleChange("name", event.name)
        }
    }

    createCheckExistingNameValidator(): ValidatorFn {
        return (control:AbstractControl) : ValidationErrors | null => {

            if (!control.value || !this.linqsetNode) {
                return null;
            }

            if (isModelNode(this.superType)) return null

            const value = control.value.trim()
    
            const existing = this.existingNodes && this.existingNodes.find(n => n.name && n.name.toLowerCase() === value.toLowerCase() && n._key !== this.linqsetNode._key)
    
            return existing ? {noExistingName:true}: null;
        }
    }

    handleChange(control:string, value:any) {
        if (this.changing) return
        this.changing = true

        try {
            if (control === "tagKeys")
                this.tagSelectionChange(value)
            else if (control === "name" || control === "description" || control === "external" || control === "type"  || control === "url"  || control === "notes" || control === "userKeys" || control === "informationAssetKey") {
                if (control === "informationAssetKey") {
                    this.currentInformationAsset = value
                    if (this.currentInformationAsset && this.currentInformationAsset !== null) this.informationAssetControl.setValue(this.currentInformationAsset.name)
                    value = this.currentInformationAsset?._key||null
                }
                const change = {}
                change[control] = value
                this.nodeNames.forEach(n => {
                    n[control] = value
                })
                this.emitPropertyChange(change, this.nodes)

            }else {
                const change = {properties:{}}
                change.properties[control] = value
                const changedNodes = []
                for (const n of this.nodes) {           
                    if (n.tag.node.superType === NODE_SUPERTYPE.ROLE) {
                        // can only change roles that have no people
                        if (getInsights(n.tag.node, this.linqset)?.hasPeople) continue
                        if (n.tag.node.type === NODE_TYPE.EXTERNAL_ORGANISATION && control !== "annualCost" && control !== "hourlyCost" && control !== "people") continue
                    }
                    n.tag.node.properties[control] = value
                    changedNodes.push(n)
                    if (this.linqset.isProjectModel() && !n.tag.node.currentState) {
                        n.tag.node.currentState = n.tag.node.properties
                    }
                }
                this.emitPropertyChange(change, changedNodes)
            }
        }finally {
            this.changing = false
        }
    }


    emitPropertyChange(change:any, changedNodes:INode[]) {
        this.graphProcessing.createChangesEvent(changedNodes, change)
    }

    // what the chosen way of combining the action's inputs means, for the items it processes and the simulation
    get processTypeHelp():string {
        switch (this.nodeGroupForm?.get('actionProcessType')?.value ?? this.nodeProperties?.actionProcessType) {
            case ACTION_FREQUENCY_TYPE.MAXIMUM: return 'Processes as many items as its busiest input sends.'
            case ACTION_FREQUENCY_TYPE.MINIMUM: return 'A batch: runs as often as its least frequent input sends (a monthly report, say), and each run takes everything that has arrived from the other inputs with it.'
            case ACTION_FREQUENCY_TYPE.AVERAGE: return 'Processes the average of what its inputs send.'
            default: return 'Processes every item that arrives from any input.'
        }
    }

    WORK_TYPE = WORK_TYPE

    readonly systemKinds = [SYSTEM_KIND.RECORD, SYSTEM_KIND.BUSINESS, SYSTEM_KIND.LOCAL]
    readonly systemKindLabels = SYSTEM_KIND_LABELS

    // LINQ's read of the system from its name, until the user says
    get suggestedSystemKind():SYSTEM_KIND {
        return suggestSystemKind(this.linqsetNode?.name, this.linqsetNode?.type)
    }

    // typed as plain information, how LINQ reads it is held, from the systems attached to it and its name
    get heldAsReadHelp():string {
        const node = this.linqsetNode
        if (!node || node.superType !== NODE_SUPERTYPE.INFORMATION || (node.type !== undefined && node.type !== NODE_TYPE.INFORMATION)) return ''
        const systems = (this.linqset?.edges || []).filter(e => e.type === EDGE_TYPE.SUPPLY && e.targetKey === node._key)
            .map(e => this.linqset?.getNode(e.sourceKey) || this.organisationLinqset?.getNode(e.sourceKey)).filter((n): n is LinqsetNode => !!n)
        const held = informationTypeOf(node, systems)
        return held.read
            ? `LINQ reads this as held ${INFORMATION_HELD_LABELS[informationHeld(held.type)].toLowerCase()}, from ${systems.length ? 'the systems attached to it and ' : ''}its name. Change its type to say how it is held.`
            : ''
    }

    // what the kind of system means for the EPM scorecard's information risk
    get systemKindHelp():string {
        const kind = this.nodeProperties?.systemKind || this.suggestedSystemKind
        const read = this.nodeProperties?.systemKind ? '' : "Read from its name: say which it is if that's wrong. "
        switch (kind) {
            case SYSTEM_KIND.RECORD: return read + 'Holds the authoritative copy of its information.'
            case SYSTEM_KIND.LOCAL: return read + "Someone's own tool, such as a spreadsheet or email: information kept in it, or passed through it, is a risk."
            default: return read + "Does the work, but isn't where the authoritative copy is kept."
        }
    }

    // what the kind of work means for the action, and what LINQ read from the process where it matters
    get workTypeHelp():string {
        const i = this.insights
        const said = this.nodeProperties?.workType
        const detour = i?.onDetour
            ? `Items leave the main flow at ${this.nodeName(i.detourSplitKey)} and return at ${this.nodeName(i.detourJoinKey)} (${Math.round((i.detourShare || 0)*100)}% of them)`
            : ''
        const onDetour = detour ? ' ' + detour + '.' : ''
        switch (said) {
            case WORK_TYPE.EXCEPTION:
                return `Fixing or chasing something that went wrong: friction on the EPM scorecard, and it earns no share of the value.${onDetour}`
            case WORK_TYPE.NOT_VALUE_ADDING:
                return `Waste, such as re-keying, duplicate checks or moving information: friction on the EPM scorecard, and it earns no share of the value.${onDetour}`
            case WORK_TYPE.NECESSARY:
                return `Required but not valued by the customer: the cost of doing business, not friction, and it earns no share of the value. Would the customer, or a regulator, notice if it stopped?${onDetour}`
            case WORK_TYPE.VALUE_ADDING:
            case WORK_TYPE.NORMAL:
                return `Changes what the customer gets: it earns a share of the value it helps create.${onDetour}`
            case WORK_TYPE.WAITING:
                return 'Items wait here for someone or something, such as an approval or a delivery. Its duration is how long they wait: it counts as no hours of work, no cost and no share of the value.'
        }
        if (this.waitsAsRead) {
            return 'Nobody does this step, so LINQ reads it as items waiting: its duration is how long they wait, not hours of work. Add a role or system if someone does the work here.'
        }
        return detour
            ? `${detour}, so LINQ reads this as exception work: friction on the EPM scorecard. Confirm it, or say what kind of work it is.`
            : 'On the main flow, so LINQ reads it as value adding. Say if it is necessary (compliance, controls, approvals), exception work, other waste or waiting.'
    }

    // the kind of work LINQ reads from the process, where the user hasn't said
    get linqReadsWorkAs():string {
        return this.waitsAsRead ? 'waiting' : this.insights?.onDetour ? 'exception' : 'value adding'
    }

    private get waitsAsRead():boolean {
        return !!this.linqsetNode && !!this.linqset && readAsWait(this.linqsetNode, this.linqset.edges)
    }

    private nodeName(key:string|undefined):string {
        return (key && this.linqset?.getNode(key)?.name) || 'an earlier step'
    }

    // a value the user types is their own, so it no longer carries the source of a suggestion it replaced
    handleOutputValueChange(value:any) {
        this.handleChange('outputValue', value)
        if (this.nodeProperties?.outputValueSource) this.handleChange('outputValueSource', null)
    }

    // accepts the value LINQ derived from how the output is used as the output's value per item
    useDerivedValue() {
        const derived = this.insights?.derivedValue
        if (!derived) return
        this.handleChange('outputValue', derived)
        this.handleChange('outputValueSource', OUTPUT_VALUE_SOURCE.DERIVED)
    }

    // the models an output joined into another model feeds, which its value and revenue come from
    private get joinedModelKeys():string[] {
        if (!this.linqsetNode || !this.linqset) return []
        return [...new Set(this.linqsetNode.insights
            .filter(i => i.modelKey !== this.linqsetNode.modelKey && i.modelKey !== ORGANISATION_MODEL_KEY && i.projectKey === this.linqset.workspaceKey)
            .map(i => i.modelKey))]
    }

    get joinedModelCount():number {
        return this.joinedModelKeys.length
    }

    get joinedModelNames():string {
        const names = this.joinedModelKeys.map(k => this.organisation?.models?.find(m => m._key === k)?.name).filter(n => !!n)
        if (!names.length) return 'another model'
        return names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
    }

    get currencySymbol():string {
        return getCurrency(this.organisation?.currencyCode || DEFAULT_CURRENCY).symbol
    }

    // a value or revenue set on an output before it was joined, which no longer counts
    clearJoinedValue() {
        this.handleChange('outputValue', 0)
        this.handleChange('outputRevenue', 0)
        if (this.nodeProperties?.outputValueSource) this.handleChange('outputValueSource', null)
    }

    // what the derived value rests on, in words
    get derivedValueReasons():string {
        const i = this.insights
        if (!i) return ''
        const reasons:string[] = []
        const items = i.numberProcessed || 0
        if (i.revenue > 0 && items > 0) reasons.push(`${Math.round(i.revenue / items).toLocaleString()} of revenue reaches each item`)
        if (i.outcomesReached > 0) reasons.push(`it reaches ${i.outcomesReached} outcome${i.outcomesReached === 1 ? '' : 's'}`)
        if (i.consumers > 0) reasons.push(`${i.consumers} action${i.consumers === 1 || i.outcomesReached > 0 ? '' : 's'}${i.outcomesReached > 0 ? ' or outcome' + (i.consumers === 1 ? '' : 's') : ''} use${i.consumers === 1 ? 's' : ''} it directly`)
        if (i.consumerModels > 0) reasons.push(`it is used in ${i.consumerModels} other model${i.consumerModels === 1 ? '' : 's'}`)
        if (i.externalConsumers > 0) reasons.push(`${i.externalConsumers} external organisation${i.externalConsumers === 1 ? '' : 's'} work${i.externalConsumers === 1 ? 's' : ''} with it`)
        return reasons.length ? reasons.join(', ') : 'value set by users flows back to it'
    }

    onOutputPercentageChange(edge:LinqsetEdge) {
        this.graphProcessing.createLinqsetEdgesChangeEvent([edge], CHANGE_TYPE.CHANGED, false, {_key: edge._key, outputPercentage: edge.outputPercentage})
    }

    openTempoDialog() {

        const calculatedNum = this.linqsetNode?.superType === NODE_SUPERTYPE.ACTION ? (this.insights?.calculatedNumberProcessed||0) : undefined

        const data:FrequencyDialogData = {properties:this.nodeProperties, superType:this.superType, type:this.linqsetNode?.type, calculatedNum, readonly:this.readonly}

        const dialogRef = this.dialog.open(FrequencyDialogComponent, {data, width:'610px', hasBackdrop:true });
        dialogRef.afterClosed().subscribe((result:FrequencyDialogResult|undefined) => {
            if (result)  {
                if (result.durationChange) {
                    this.nodeProperties.duration = result.duration
                    this.handleChange("duration", result.duration)
                }
                if (result.frequencyChange) {
                    this.nodeProperties.frequency = result.frequency
                    this.handleChange("frequency", result.frequency)
                }
                this.tempo = getTempoMessageAndColour(this.superType, this.nodeProperties, this.insights, this.linqset.workspaceKey, this.linqsetNode, defaultCapacityHours(this.linqset.organisation))
            }
        })
    }  

    getTagGroups() {
        return getTagGroupsForModel(this.organisation, this.linqset.modelKey)
    }

    getNodeTagsForGroup() {
        return []
    }

    getColourStyleForTag(tag) {
        return this.tagsSevice.getColourStyleForTag(tag)
    }

    setupModelsList() {
        let startingInsights
        const modelMap = (this.linqsetNode.insights || []).reduce((m, i:NodeInsights) => {
            let value = undefined

            if (i.modelKey === ORGANISATION_MODEL_KEY) {
                value = {_key:i.modelKey, insights:i, name:"Organisation"}
            }else if (i.modelKey === TUTORIAL_MODEL_KEY) {
                value = {_key:i.modelKey, insights:i, name:"Tutorial"}
            }else if (i.modelKey === FILTER_MODEL_KEY) {
                value = {_key:i.modelKey, insights:i, name:"Filtered"}

            }else {
                const model = this.organisation.models.find(m => m._key === i.modelKey)
                if (model) {
                    value = {_key:model._key, insights:i, name:model.name}
                }                    
            }

            if (value) {
                const project = i.projectKey && this.organisation.projects.find(p => p._key === i.projectKey)
                if (project) {
                    if (!m[project._key]) m[project._key] = {name:project.name, models:[]}

                    value.selectedName = project.name + " - " + value.name
                    m[project._key].models.push(value)
                }else {
                    if (!m[CURRENT_STATE_PROJECT_KEY]) m[CURRENT_STATE_PROJECT_KEY] = {name:'Current state', models:[]}

                    value.selectedName = "Current state - " + value.name
                    m[CURRENT_STATE_PROJECT_KEY].models.push(value)
                }
                if (value.insights.modelKey === this.insights?.modelKey && value.insights.projectKey === this.insights?.projectKey) startingInsights = value
            }
            return m
        }, {})
        this.models = Object.values(modelMap)
        this.tileInsights = startingInsights
    }

    tagSelectionChange(tags:any[]) {
        updateTagsOnProperties(this.organisation, this.nodeProperties, tags)

        this.nodeGroupForm.controls['tagKeys'].setValue(Object.values(this.nodeProperties.tagKeys))
        
        this.nodeNames.forEach(n => {
            n.properties.tagKeys = this.nodeProperties.tagKeys
        })
        const change = {properties:{tagKeys:this.nodeProperties.tagKeys}}
        this.emitPropertyChange(change, this.nodes)
    }

    createTiles() {
        this.cards = []
        if (this.nodeNames.length > 1 || !this.superType || !this.tileInsights || !this.linqsetNode || this.superType === NODE_SUPERTYPE.NOTES) return
        
        if (this.linqset.isDirty() && this.linqset.workspaceKey !== this.tileInsights.insights.projectKey) {
            this.invalidInsightsMessage = "Insights are out of date. Save changes to refresh insights"
        }else this.invalidInsightsMessage = undefined

        const nodeInsights = this.tileInsights.insights as NodeInsights
        const currentStateInsights = this.tileInsights.insights.projectKey !== CURRENT_STATE_PROJECT_KEY && getInsightsForNode(this.linqsetNode, this.tileInsights.insights.modelKey, CURRENT_STATE_PROJECT_KEY)

        if (nodeInsights.normalisedCentrality) {
            this.cards.push(new InsightCard("Centrality", this.linqsetNode.type, 'Relative importance of node', null, nodeInsights.normalisedCentrality, currentStateInsights?.normalisedCentrality))
        }

        if (isSupplyChain(this.superType) || isRoleSystem(this.superType))
            this.cards.push(new InsightCard("Processed", this.linqsetNode.type, 'Number processed per annum', null, nodeInsights.numberProcessed, currentStateInsights?.numberProcessed))

        // the work and those doing it: what they contribute (their share, so steps, roles and systems add up) beside what
        // they support (the value of everything depending on them), and what would be lost if they stopped
        const doesWork = this.superType === NODE_SUPERTYPE.ACTION || isRoleSystem(this.superType)
        if (isModelNode(this.superType) && !doesWork) {
            if (nodeInsights.value) this.cards.push(new InsightCard("Value", NODE_TYPE.INFORMATION, 'Infometric value', null, nodeInsights.value, currentStateInsights?.value))
            else this.cards.push(new InsightCard("Value", NODE_TYPE.INFORMATION, 'Infometric value has not been set', "Not available"))
        }
        if (doesWork && (nodeInsights.value || nodeInsights.revenue)) {
            const cost = (i:NodeInsights|undefined) => i?.allocatedCostsByType?.total || 0
            const margin = (i:NodeInsights|undefined) => i ? (i.contributedRevenue || 0) - cost(i) : undefined
            if (nodeInsights.value) {
                this.cards.push(new InsightCard("Value contribution", NODE_TYPE.INFORMATION, 'Its share of the value it helps create', null, Math.round(nodeInsights.contributedValue || 0), currentStateInsights && Math.round(currentStateInsights.contributedValue || 0)))
                this.cards.push(new InsightCard("Value supported", NODE_TYPE.INFORMATION, 'Value of the outputs and outcomes that depend on it', null, nodeInsights.value, currentStateInsights?.value))
            }
            if (nodeInsights.atRiskValue) this.cards.push(new InsightCard("Value at risk", NODE_TYPE.INFORMATION, 'Value lost if it stopped, as its items have no other route', null, Math.round(nodeInsights.atRiskValue), currentStateInsights && Math.round(currentStateInsights.atRiskValue || 0)))
            if (nodeInsights.revenue) {
                this.cards.push(new InsightCard("Revenue contribution", this.linqsetNode.type, 'Its share of the revenue it helps create', null, Math.round(nodeInsights.contributedRevenue || 0), currentStateInsights && Math.round(currentStateInsights.contributedRevenue || 0), INSIGHT_VALUE_TYPE.CURRENCY))
                this.cards.push(new InsightCard("Revenue margin", this.linqsetNode.type, 'Revenue contribution less the cost of its work', null, Math.round(margin(nodeInsights)!), currentStateInsights ? Math.round(margin(currentStateInsights)!) : undefined, INSIGHT_VALUE_TYPE.CURRENCY))
                this.cards.push(new InsightCard("Revenue supported", this.linqsetNode.type, 'Revenue of the outputs and outcomes that depend on it', null, nodeInsights.revenue, currentStateInsights?.revenue, INSIGHT_VALUE_TYPE.CURRENCY))
                if (nodeInsights.atRiskRevenue) this.cards.push(new InsightCard("Revenue at risk", this.linqsetNode.type, 'Revenue lost if it stopped, as its items have no other route', null, Math.round(nodeInsights.atRiskRevenue), currentStateInsights && Math.round(currentStateInsights.atRiskRevenue || 0), INSIGHT_VALUE_TYPE.CURRENCY))
            }
        }

        if (this.superType !== NODE_SUPERTYPE.OUTCOMES) {
            this.cards.push(new InsightCard("Hours", NODE_TYPE.ACTION, 'Hours per annum', null, nodeInsights.hours, currentStateInsights?.hours))

            if (this.superType !== NODE_SUPERTYPE.INFORMATION) {
                if (nodeInsights.modelledCapacity) this.cards.push(new InsightCard("Modelled capacity", NODE_TYPE.ROLE, 'Hours available to work that have been modelled', null, nodeInsights.modelledCapacity, currentStateInsights?.modelledCapacity))
                    
                this.cards.push(new InsightCard("Number of people", NODE_TYPE.ROLE, 'Number of people available', null, nodeInsights.numPeople, currentStateInsights?.numPeople))
            }
        }
        
        if (this.linqsetNode.type !== NODE_TYPE.EXTERNAL_ORGANISATION && nodeInsights.modelledCapacity && (this.superType === NODE_SUPERTYPE.ACTION || isRolePeople(this.superType) || isSystemInfrastructure(this.superType))) {
            const remaining = nodeInsights.modelledCapacity-nodeInsights.hours
            const remainingCompare = currentStateInsights?.modelledCapacity?currentStateInsights.modelledCapacity-currentStateInsights.hours:undefined

            const unusedCapacityCard = new InsightCard("Remaining capacity", NODE_TYPE.ROLE, 'Hours of capacity remaining after hours worked.', null, remaining, remainingCompare)
            this.cards.push(unusedCapacityCard)
            
            if (this.linqsetNode.properties?.percentageModelled && this.linqsetNode.properties?.percentageModelled !== 100) {
                const unmodelled = convertModelledCapacityToTotal(nodeInsights.modelledCapacity, this.linqsetNode.properties?.percentageModelled)
                this.cards.push(new InsightCard("Unmodelled capacity", NODE_TYPE.ROLE, 'Hours that have not been modelled', null, unmodelled-nodeInsights.modelledCapacity))
            }
        }

        if (nodeInsights.allocatedCostsByType) {
            Object.keys(nodeInsights.allocatedCostsByType.map).forEach(t => {
                const sType = parseInt(t) as NODE_SUPERTYPE
                const name = getSuperTypeName(sType)
                this.cards.push(new InsightCard(`Allocated (modelled) cost`, this.nodeService.getNodeTypeForSuperType(sType).type, `Cost from ${name}`, null, getIndexValue(nodeInsights.allocatedCostsByType, t), currentStateInsights && getIndexValue(currentStateInsights.allocatedCostsByType, t), INSIGHT_VALUE_TYPE.CURRENCY))
            })
        }

        if (isOrganisationNode(this.superType) && nodeInsights.modelKey === ORGANISATION_MODEL_KEY) {
            const orgInsights = getInsightsForNode(this.linqsetNode, ORGANISATION_MODEL_KEY, nodeInsights.projectKey)
            if (orgInsights?.costAllocation) {
                const currentStateOrgInsights = this.tileInsights.insights.projectKey !== CURRENT_STATE_PROJECT_KEY && getInsightsForNode(this.linqsetNode, ORGANISATION_MODEL_KEY, CURRENT_STATE_PROJECT_KEY)
                this.cards.push(new InsightCard("Unallocated costs", this.linqsetNode.type, 'Costs not allocated (unused capacity)', null, orgInsights.costAllocation.unallocated, currentStateOrgInsights?.costAllocation?.unallocated, INSIGHT_VALUE_TYPE.CURRENCY))
                this.cards.push(new InsightCard("Unmodelled costs", this.linqsetNode.type, 'Costs not included in any model', null, orgInsights.costAllocation.unmodelled, currentStateOrgInsights?.costAllocation?.unmodelled, INSIGHT_VALUE_TYPE.CURRENCY))
            }
        }

        const rolesAndSystems = this.linqset.getAssociatedRolesAndSystems(this.linqsetNode)

        if (this.superType === NODE_SUPERTYPE.ACTION) {
            this.cards.push(new InsightCard("Automated", NODE_TYPE.SYSTEM, 'Whether action is automated', nodeInsights.actionType === ACTION_TYPE.AUTOMATED?"Yes":"No"))
            if (rolesAndSystems.systems.length > 0) {
                this.cards.push(new InsightCard("System", rolesAndSystems.systems[0].type, 'System used in action', rolesAndSystems.systems[0].name))
            }
            if (rolesAndSystems.roles.length > 0) {
                this.cards.push(new InsightCard("Role", rolesAndSystems.roles[0].type, 'Role performing action', rolesAndSystems.roles[0].name))
            }
        }

        if (this.superType === NODE_SUPERTYPE.INFORMATION && rolesAndSystems.systems.length > 0) {
            this.cards.push(new InsightCard("System", rolesAndSystems.systems[0].type, 'System that supplied information', rolesAndSystems.systems[0].name))
        }

        if (isRoleSystem(this.superType)) {
            this.cards.push(new InsightCard("Actions", NODE_TYPE.ACTION, 'Number of actions', null, nodeInsights.numActionsSupported, currentStateInsights?.numActionsSupported))
            this.cards.push(new InsightCard("Outputs supported", NODE_TYPE.INFORMATION, 'Number of output nodes supported', null, nodeInsights.outputsSupported, currentStateInsights?.outputsSupported))
        }

        if (nodeInsights.allocatedCarbonByScope) {
            Object.keys(nodeInsights.allocatedCarbonByScope.map).forEach(s => {
                const csEmissions = currentStateInsights?.allocatedCarbonByScope?.map[s]
                const emissionsCard = new InsightCard(s + " emissions", NODE_TYPE.INFRASTRUCTURE, s + ' carbon emissions', null, nodeInsights?.allocatedCarbonByScope?.map[s], csEmissions)
                emissionsCard.icon = getCarbonScopeIcon(s as CARBON_SCOPE)
                this.cards.push(emissionsCard)
            })
        }

        if (this.superType === NODE_SUPERTYPE.SYSTEM) {
            this.cards.push(new InsightCard("Info supplied", NODE_TYPE.INFORMATION, 'Number of information states supplied', null, nodeInsights.numInfoSupplied))
            Object.keys(nodeInsights.timeUsedByRole?.map || {}).forEach(k => {
                const role = k!==NO_ROLE && this.organisationLinqset?.getNode(k)
                const percent = nodeInsights.hours?Math.round(100*getIndexValue(nodeInsights.timeUsedByRole, k)/nodeInsights.hours):0

                this.cards.push(new InsightCard(k===NO_ROLE?"Automated":(role?.name || "Unknown role"), NODE_TYPE.ROLE, 'Hours role uses system', `${Math.round(getIndexValue(nodeInsights.timeUsedByRole, k))} (${percent}%)`))
            })
        }

        if (isModelNode(this.superType)) {
            this.cards.push(new InsightCard("Total hours", NODE_TYPE.ACTION, 'Total hours to this point', null, nodeInsights.totalHours, currentStateInsights?.totalHours))
            this.cards.push(new InsightCard("Total carbon", NODE_TYPE.ACTION, 'Total carbon produced to this point', null, nodeInsights.totalCarbon, currentStateInsights?.totalCarbon))
            if (nodeInsights.totalAllocatedCostsByType) {
                Object.keys(nodeInsights.totalAllocatedCostsByType.map).forEach(t => {
                    const sType = parseInt(t) as NODE_SUPERTYPE
                    const name = getSuperTypeName(sType)
                    this.cards.push(new InsightCard(`Total ${name} cost`, this.nodeService.getNodeTypeForSuperType(sType).type, `Cumulative ${name} costs up to this point in graph`, null, getIndexValue(nodeInsights.totalAllocatedCostsByType, t), currentStateInsights && getIndexValue(currentStateInsights.totalAllocatedCostsByType, t), INSIGHT_VALUE_TYPE.CURRENCY))
                })
            }
        }

        if (nodeInsights.revenue && !doesWork) {
            this.cards.push(new InsightCard("Revenue", this.linqsetNode.type, 'Revenue created', null, nodeInsights.revenue, currentStateInsights?.revenue, INSIGHT_VALUE_TYPE.CURRENCY))
        }
    }
}
